import { doPost, doGet } from 'services/common'

export const processPollVote = (pollId, questionId, answerId) => {
  const payload = {
    pollId: pollId,
    questionId: questionId,
    answerId: answerId,
  }

  return doPost('/poll/vote', payload)
}
export const awardPoints = (breakId, stepId, nonce) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    nonce: nonce,
  }

  return doPost(`/poll/awardPoints`, payload)
}
export const getPollQuestionAnswerCounts = (pollId, questionId) => {
  return doGet(`/poll/${pollId}/${questionId}/votes`)
}

export const start = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/poll/start`, payload)
}

export const complete = (breakId, stepId, nonce, stepSkipped) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    nonce: nonce,
    skipped: stepSkipped,
  }

  return doPost(`/poll/complete`, payload)
}
